import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)<{ mainImage?: string }>`
  padding-bottom: 18px;

  ion-content {
    --background: url(${(props) =>
        props.mainImage ||
        '/assets/layout-own-ai-dominate-v2/jia/summary-screens/summary-final-background.png'})
      no-repeat center center / cover;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 49.96%,
        #000 82%,
        #000 100%
      );
      backdrop-filter: blur(10px);
      z-index: 1;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      pointer-events: none;
      background: rgba(0, 0, 0, 0.5);
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      position: relative;
      z-index: 2;
    }
  }

  .title {
    margin-bottom: 8px;
  }

  .subtitle {
    text-align: center;
  }
`;

export const SubtitleStyles = styled(UiTypography)`
  margin-bottom: 16px;
`;

export const ContentContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 2;
`;

export const PlayerContainerStyles = styled.div`
  width: 100%;
  max-width: 320px;
  height: auto;
  max-height: 320px;

  @media (max-width: 375px) {
    max-width: 275px;
    max-height: 275px;
  }

  lottie-player {
    width: 100% !important;
    height: 100% !important;
  }
`;
